import { FeedBackModalNew, modal } from '@/lib/shared/components/Modal';

type OpenConciergeLeadModalOptions = {
  sourceForm?: string;
  comment?: string;
};

export const openConciergeLeadModal = ({
  sourceForm = 'concierge_hero',
  comment,
}: OpenConciergeLeadModalOptions = {}) => {
  modal.open(
    <FeedBackModalNew
      title="requestACall"
      messengerText="viaMessenger"
      leadType="CONCIERGE"
      eventName={['concierge']}
      sourceForm={sourceForm}
      comment={comment}
    />,
    { isFeedBackNew: true, skipUrlSync: true }
  );
};
